module.exports = __webpack_public_path__ + "static/media/09 - Expert B.daf613c4.png";